import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
  ViewEncapsulation,
  ViewChild,
  ElementRef
} from '@angular/core';
import { Alert } from '../reservation-settings.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import 'rxjs/add/operator/takeUntil';
import { Observable, Subject } from 'rxjs';
import { ReservationService } from '@app/reservation/reservation.service';
import moment from 'moment';
moment.locale('de');
import { NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { resStatus } from '@app/core/constants';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-add-time-filter',
  templateUrl: './add-time-filter.component.html',
  styleUrls: ['./add-time-filter.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AddTimeFilterComponent implements OnInit, OnDestroy {
  @Input() public editTimeFilterData: any; // only if editing
  @Input() public shiftData: any = [];
  @Input() public roomData: any = [];
  @Input() public tagData: any = [];
  @Input() public allStatusData: any = [];
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  resTimeFilterFormGroup: FormGroup;
  private ngUnsubscribe: Subject<any> = new Subject();
  time1: NgbTimeStruct;
  time2: NgbTimeStruct;
  allStatus: any[] = resStatus;
  tablesData: any = [];
  rooms: any = [];
  shifts: any = [];
  allTags: any = [];
  isLoading = false;

  constructor(
    public activeModal: NgbActiveModal,
    public formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private reservationService: ReservationService
  ) {}

  ngOnInit() {
    this.loadFilter();
    this.resTimeFilterFormGroup = this.formBuilder.group({
      name: ['', Validators.required],
      from: ['', Validators.required],
      to: ['', Validators.required],
      roomIds: [null],
      shiftId: [null],
      tagIds: [null],
      status: [null]
    });
  }

  async loadFilter() {
    this.isLoading = true;
    try {
      this.allStatus = this.allStatusData || resStatus;

      const tagPromise = this.tagData && this.tagData.length ? Promise.resolve(this.tagData) : this.getAllTags();
      const shiftPromise = this.shiftData && this.shiftData.length ? Promise.resolve(this.shiftData) : this.getShifts();
      const roomPromise = this.roomData && this.roomData.length ? Promise.resolve(this.roomData) : this.getRooms();

      const [tags, shifts, rooms] = await Promise.all([tagPromise, shiftPromise, roomPromise]);

      this.allTags = tags;
      this.shifts = shifts;
      this.rooms = rooms;
      if (this.editTimeFilterData) {
        let timeFrom = this.editTimeFilterData.from.split(':');
        this.time1 = {
          hour: parseInt(timeFrom[0]),
          minute: parseInt(timeFrom[1]),
          second: 0
        };
        let timeTo = this.editTimeFilterData.to.split(':');
        this.time2 = {
          hour: parseInt(timeTo[0]),
          minute: parseInt(timeTo[1]),
          second: 0
        };
        this.resTimeFilterFormGroup.addControl('id', new FormControl(this.editTimeFilterData.id, Validators.required));
        this.resTimeFilterFormGroup.get('from').setValue(this.time1);
        this.resTimeFilterFormGroup.get('to').setValue(this.time2);
        this.resTimeFilterFormGroup.get('name').setValue(this.editTimeFilterData.name);
        this.resTimeFilterFormGroup.get('status').setValue(this.editTimeFilterData.status || null);
        const editTagIds = this.parseIdCsv(this.editTimeFilterData.tagIds);
        const editTagObjects = editTagIds
          .map((id: number) => this.allTags.find((t: any) => Number(t.id) === id))
          .filter((t: any) => !!t);
        this.resTimeFilterFormGroup.get('tagIds').setValue(editTagObjects.length ? editTagObjects : null);
        const editRoomIds = this.parseIdCsv(this.editTimeFilterData.roomIds);
        this.resTimeFilterFormGroup.get('roomIds').setValue(editRoomIds.length ? editRoomIds : null);
        this.resTimeFilterFormGroup.get('shiftId').setValue(this.editTimeFilterData.shiftId || null);
      }
    } finally {
      this.isLoading = false;
    }
  }

  async getRooms(): Promise<any[]> {
    const data = await this.reservationService.getRooms(false).toPromise();

    if (!data) {
      return [];
    }

    const rooms = [...data];

    const allTables: any[] = [];
    rooms.forEach((room: any) => {
      allTables.push(...room.tables);
    });

    const allRooms = { ...rooms[0], id: 1000, name: 'All', tables: allTables };

    rooms.push(allRooms);

    // Assign state (optional)
    this.rooms = rooms;
    this.tablesData = rooms.length ? rooms[0].tables : [];

    return rooms;
  }

  async getShifts(): Promise<any[]> {
    const shifts = await this.reservationService
      .getShifts()
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise();

    this.shifts = shifts;

    if (this.editTimeFilterData) {
      this.resTimeFilterFormGroup.get('shiftId').setValue(this.editTimeFilterData.shiftId || null);
    }

    return shifts;
  }

  async getAllTags(): Promise<any[]> {
    const tags = await this.reservationService
      .getTags()
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise();

    this.allTags = tags;
    return tags;
  }

  parseIdCsv(value: any): number[] {
    if (value == null || value === '') {
      return [];
    }
    const raw = Array.isArray(value) ? value : String(value).split(',');
    return raw
      .map((v: any) => (v && typeof v === 'object' ? v.id : v))
      .map((v: any) => Number(v))
      .filter((v: number) => !Number.isNaN(v));
  }

  toIdCsv(value: any): string | null {
    const ids = this.parseIdCsv(value);
    return ids.length ? ids.join(',') : null;
  }

  add() {
    if (!this.resTimeFilterFormGroup.valid) {
      this.snackBar.open('Bitte überprüfen Sie Ihre Angaben.', '', {
        duration: 2000,
        panelClass: ['snackbar-error']
      });
      return;
    }
    const payload = { ...this.resTimeFilterFormGroup.value };
    payload.from = `${String(payload.from.hour).padStart(2, '0')}:${String(payload.from.minute).padStart(2, '0')}`;
    payload.to = `${String(payload.to.hour).padStart(2, '0')}:${String(payload.to.minute).padStart(2, '0')}`;
    payload.tagIds = this.toIdCsv(payload.tagIds);
    payload.roomIds = this.toIdCsv(payload.roomIds);
    this.passEntry.emit(payload);
  }

  ngOnDestroy(): any {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
